module.exports = __webpack_public_path__ + "img/undefined.59738d70.png";